import React, { useState } from "react";
import { FaPlus, FaTrash, FaChevronUp, FaChevronDown } from "react-icons/fa";
import { COUNTRY_OPTIONS, createEmptyEducation, createEmptyCertification, createEmptyTraining, createEmptyVisa, createEmptyCDC, createEmptyCoC } from "../constants";

const Tab2Qualifications = ({
  travelDocuments,
  setTravelDocuments,
  marineDocuments,
  setMarineDocuments,
  educationRecords,
  setEducationRecords,
  certificationRecords,
  setCertificationRecords,
  trainingRecords,
  setTrainingRecords,
  errors,
  loading,
  addRecord,
  removeRecord,
  handleRecordChange,
  handleRecordFileChange,
  removeEducationRecord,
  removeCertificationRecord,
  removeTrainingRecord,
  removeCdcRecord,
  removeCocRecord,
  onSubmit,
  onBack
}) => {
  const [expandedSections, setExpandedSections] = useState({
    travel: true,
    marine: true,
    education: true,
    certification: true,
    training: true,
  });

  const toggleSection = (key) => {
    setExpandedSections((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleVisaChange = (index, field, value) => {
    const updatedVisas = travelDocuments.visas.map((visa, idx) =>
      idx === index ? { ...visa, [field]: value } : visa
    );
    setTravelDocuments((prev) => ({ ...prev, visas: updatedVisas }));
  };

  const addVisa = () => {
    setTravelDocuments((prev) => ({
      ...prev,
      visas: [...prev.visas, createEmptyVisa()],
    }));
  };

  const removeVisa = (index) => {
    setTravelDocuments((prev) => {
      const updated = prev.visas.length === 1
        ? [createEmptyVisa()]
        : prev.visas.filter((_, idx) => idx !== index);
      return { ...prev, visas: updated };
    });
  };

  const safeMarineDocuments = marineDocuments || { cdc: [], coc: [] };

  const handleCDCChange = (index, field, value) => {
    setMarineDocuments((prev = { cdc: [], coc: [] }) => ({
      ...prev,
      cdc: prev.cdc.map((item, idx) =>
        idx === index ? { ...item, [field]: value } : item
      ),
    }));
  };

  const addCDC = () => {
    setMarineDocuments((prev) => ({
      ...prev,
      cdc: [...prev.cdc, createEmptyCDC()],
    }));
  };

    const removeCDC = (index) => {
    removeCdcRecord(index);
  };

  const handleCoCChange = (index, field, value) => {
    setMarineDocuments((prev) => ({
      ...prev,
      coc: prev.coc.map((item, idx) =>
        idx === index ? { ...item, [field]: value } : item
      ),
    }));
  };

  const addCoC = () => {
    setMarineDocuments((prev) => ({
      ...prev,
      coc: [...prev.coc, createEmptyCoC()],
    }));
  };

    const removeCoC = (index) => {
    removeCocRecord(index);
  };

  const handleTrainingChange = (index, field, value) => {
    setTrainingRecords((prev) => prev.map((item, idx) =>
      idx === index ? { ...item, [field]: value } : item
    ));
  };

  const addTraining = () => {
    setTrainingRecords((prev) => [...prev, createEmptyTraining()]);
  };

    const removeTraining = (index) => {
    removeTrainingRecord(index);
  };

  return (
    <div>
      {/* Section 4: Travel Documents */}
      <div className="register-stage2-section">
        <div
          className="register-stage2-section__header"
          onClick={() => toggleSection("travel")}
        >
          <div className="register-stage2-section__header-top">
            <h3 className="register-stage2-section__title">
              <span className="register-stage2-section__icon">🛂</span>
              4. Travel Documents
            </h3>
            <span className="register-stage2-section__chevron">
              {expandedSections.travel ? <FaChevronUp /> : <FaChevronDown />}
            </span>
          </div>
          <p className="register-stage2-section__subtitle">
            Passport and visa information.
          </p>
        </div>

        {expandedSections.travel && (
          <>
            <div className="register-stage2-form__grid register-stage2-form__grid--4col">
              <div className="register-stage2-form__field-group">
                <label className="register-stage2-form__label">Passport Number</label>
                <input
                  type="text"
                  className="register-stage2-form__input"
                  value={travelDocuments.passport_number}
                  onChange={(e) => setTravelDocuments({...travelDocuments, passport_number: e.target.value})}
                  placeholder="Passport number"
                  disabled={loading}
                />
              </div>

              <div className="register-stage2-form__field-group">
                <label className="register-stage2-form__label">Passport Country</label>
                <select
                  className="register-stage2-form__select"
                  value={travelDocuments.passport_country}
                  onChange={(e) => setTravelDocuments({...travelDocuments, passport_country: e.target.value})}
                  disabled={loading}
                >
                  <option value="">Select country</option>
                  {COUNTRY_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>

              <div className="register-stage2-form__field-group">
                <label className="register-stage2-form__label">Passport Expiry</label>
                <input
                  type="date"
                  className="register-stage2-form__input"
                  value={travelDocuments.passport_expiry}
                  onChange={(e) => setTravelDocuments({...travelDocuments, passport_expiry: e.target.value})}
                  disabled={loading}
                />
              </div>
            </div>

            <div className="register-stage2-subsection">
              <div className="register-stage2-section__header-row">
                <div>
                  <h4 className="register-stage2-section__title">
                    Visa / Work Permit
                  </h4>
                  <p className="register-stage2-section__subtitle">
                    Visa and work permit records that can be repeated for multiple permits.
                  </p>
                </div>
                <button
                  type="button"
                  className="register-stage2-add-btn"
                  onClick={addVisa}
                  disabled={loading}
                >
                  <FaPlus /> Add visa / work permit
                </button>
              </div>

              {travelDocuments.visas.map((visa, index) => (
                <div key={visa.id} className="register-stage2-record-card register-stage2-record-card--compact">
                  <div className="register-stage2-record-card__header">
                    <h4 className="register-stage2-record-card__title">
                      Visa / work permit #{index + 1}
                    </h4>
                    {travelDocuments.visas.length > 1 && (
                      <button
                        type="button"
                        className="register-stage2-record-card__remove"
                        onClick={() => removeVisa(index)}
                        disabled={loading}
                      >
                        <FaTrash />
                      </button>
                    )}
                  </div>
                  <div className="register-stage2-form__grid register-stage2-form__grid--4col">
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">Country</label>
                      <select
                        className="register-stage2-form__select"
                        value={visa.country}
                        onChange={(e) => handleVisaChange(index, "country", e.target.value)}
                        disabled={loading}
                      >
                        <option value="">Select...</option>
                        {COUNTRY_OPTIONS.map((opt) => (
                          <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                      </select>
                    </div>
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">Visa / permit type</label>
                      <input
                        type="text"
                        className="register-stage2-form__input"
                        value={visa.visa_type}
                        onChange={(e) => handleVisaChange(index, "visa_type", e.target.value)}
                        placeholder="Work visa, business visa..."
                        disabled={loading}
                      />
                    </div>
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">Visa number</label>
                      <input
                        type="text"
                        className="register-stage2-form__input"
                        value={visa.visa_number}
                        onChange={(e) => handleVisaChange(index, "visa_number", e.target.value)}
                        placeholder="Visa number"
                        disabled={loading}
                      />
                    </div>
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">Issue date</label>
                      <input
                        type="date"
                        className="register-stage2-form__input"
                        value={visa.issue_date}
                        onChange={(e) => handleVisaChange(index, "issue_date", e.target.value)}
                        disabled={loading}
                      />
                    </div>
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">Expiry date</label>
                      <input
                        type="date"
                        className="register-stage2-form__input"
                        value={visa.expiry_date}
                        onChange={(e) => handleVisaChange(index, "expiry_date", e.target.value)}
                        disabled={loading}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      {/* Section 5: Marine Credentials */}
      <div className="register-stage2-section">
        <div
          className="register-stage2-section__header"
          onClick={() => toggleSection("marine")}
        >
          <div className="register-stage2-section__header-top">
            <h3 className="register-stage2-section__title">
              <span className="register-stage2-section__icon">⚓</span>
              5. Marine Credentials
            </h3>
            <span className="register-stage2-section__chevron">
              {expandedSections.marine ? <FaChevronUp /> : <FaChevronDown />}
            </span>
          </div>
          <p className="register-stage2-section__subtitle">
            CDC and CoC information.
          </p>
        </div>

        {expandedSections.marine && (
          <>
            <div className="register-stage2-subsection">
              <div className="register-stage2-section__header-row">
                <div>
                  <h4 className="register-stage2-section__title">CDC / Seaman book</h4>
                </div>
                <button
                  type="button"
                  className="register-stage2-add-btn"
                  onClick={addCDC}
                  disabled={loading}
                >
                  <FaPlus /> Add cdc / seaman book
                </button>
              </div>

              {safeMarineDocuments.cdc.map((item, index) => (
                <div key={item.id} className="register-stage2-record-card register-stage2-record-card--compact">
                  <div className="register-stage2-record-card__header">
                    <h4 className="register-stage2-record-card__title">
                      CDC / Seaman book #{index + 1}
                    </h4>
                    {safeMarineDocuments.cdc.length > 1 && (
                      <button
                        type="button"
                        className="register-stage2-record-card__remove"
                        onClick={() => removeCDC(index)}
                        disabled={loading}
                      >
                        <FaTrash />
                      </button>
                    )}
                  </div>
                  <div className="register-stage2-form__grid register-stage2-form__grid--4col">
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">Issuing country</label>
                      <select
                        className="register-stage2-form__select"
                        value={item.issuing_country}
                        onChange={(e) => handleCDCChange(index, "issuing_country", e.target.value)}
                        disabled={loading}
                      >
                        <option value="">Select country</option>
                        {COUNTRY_OPTIONS.map((opt) => (
                          <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                      </select>
                    </div>
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">CDC number</label>
                      <input
                        type="text"
                        className="register-stage2-form__input"
                        value={item.number}
                        onChange={(e) => handleCDCChange(index, "number", e.target.value)}
                        placeholder="CDC number"
                        disabled={loading}
                      />
                    </div>
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">Issue date</label>
                      <input
                        type="date"
                        className="register-stage2-form__input"
                        value={item.issue_date}
                        onChange={(e) => handleCDCChange(index, "issue_date", e.target.value)}
                        disabled={loading}
                      />
                    </div>
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">Expiry date</label>
                      <input
                        type="date"
                        className="register-stage2-form__input"
                        value={item.expiry_date}
                        onChange={(e) => handleCDCChange(index, "expiry_date", e.target.value)}
                        disabled={loading}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="register-stage2-subsection">
              <div className="register-stage2-section__header-row">
                <div>
                  <h4 className="register-stage2-section__title">Certificate of Competency</h4>
                </div>
                <button
                  type="button"
                  className="register-stage2-add-btn"
                  onClick={addCoC}
                  disabled={loading}
                >
                  <FaPlus /> Add certificate of competency
                </button>
              </div>

              {safeMarineDocuments.coc.map((item, index) => (
                <div key={item.id} className="register-stage2-record-card register-stage2-record-card--compact">
                  <div className="register-stage2-record-card__header">
                    <h4 className="register-stage2-record-card__title">
                      Certificate of Competency #{index + 1}
                    </h4>
                    {safeMarineDocuments.coc.length > 1 && (
                      <button
                        type="button"
                        className="register-stage2-record-card__remove"
                        onClick={() => removeCoC(index)}
                        disabled={loading}
                      >
                        <FaTrash />
                      </button>
                    )}
                  </div>
                  <div className="register-stage2-form__grid register-stage2-form__grid--4col">
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">Grade / rank</label>
                      <input
                        type="text"
                        className="register-stage2-form__input"
                        value={item.grade}
                        onChange={(e) => handleCoCChange(index, "grade", e.target.value)}
                        placeholder="Chief Engineer, Master Mariner..."
                        disabled={loading}
                      />
                    </div>
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">Issuing authority</label>
                      <input
                        type="text"
                        className="register-stage2-form__input"
                        value={item.issuing_authority}
                        onChange={(e) => handleCoCChange(index, "issuing_authority", e.target.value)}
                        placeholder="Issuing authority"
                        disabled={loading}
                      />
                    </div>
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">Certificate number</label>
                      <input
                        type="text"
                        className="register-stage2-form__input"
                        value={item.number}
                        onChange={(e) => handleCoCChange(index, "number", e.target.value)}
                        placeholder="Certificate number"
                        disabled={loading}
                      />
                    </div>
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">Issue date</label>
                      <input
                        type="date"
                        className="register-stage2-form__input"
                        value={item.issue_date}
                        onChange={(e) => handleCoCChange(index, "issue_date", e.target.value)}
                        disabled={loading}
                      />
                    </div>
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">Expiry date</label>
                      <input
                        type="date"
                        className="register-stage2-form__input"
                        value={item.expiry_date}
                        onChange={(e) => handleCoCChange(index, "expiry_date", e.target.value)}
                        disabled={loading}
                      />
                    </div>
                    <div className="register-stage2-form__grid register-stage2-form__grid--1col">
                      <div className="register-stage2-form__field-group">
                        <label className="register-stage2-form__label">Endorsements / limitations</label>
                        <input
                          type="text"
                          className="register-stage2-form__input"
                          value={item.endorsements}
                          onChange={(e) => handleCoCChange(index, "endorsements", e.target.value)}
                          placeholder="Endorsements / limitations"
                          disabled={loading}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      {/* Section 6: Education */}
      <div className="register-stage2-section">
        <div
          className="register-stage2-section__header"
          onClick={() => toggleSection("education")}
        >
          <div className="register-stage2-section__header-top">
            <h3 className="register-stage2-section__title">
              <span className="register-stage2-section__icon">🎓</span>
              6. Education
            </h3>
            <div className="register-stage2-section__header-actions">
              <button
                type="button"
                className="register-stage2-add-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  addRecord(setEducationRecords, createEmptyEducation);
                }}
                disabled={loading}
              >
                <FaPlus /> Add Education
              </button>
              <span className="register-stage2-section__chevron">
                {expandedSections.education ? <FaChevronUp /> : <FaChevronDown />}
              </span>
            </div>
          </div>
          <p className="register-stage2-section__subtitle">
            Academic and technical qualifications.
          </p>
        </div>

        {expandedSections.education && (
          <>
            {errors.education && (
              <span className="register-stage2-form__error-text register-stage2-form__error-text--block">
                {errors.education}
              </span>
            )}

            {educationRecords.map((record, index) => (
              <div key={record.id} className="register-stage2-record-card">
                <div className="register-stage2-record-card__header">
                  <h4 className="register-stage2-record-card__title">
                    Education #{index + 1}
                  </h4>
                  {educationRecords.length > 1 && (
                    <button
                      type="button"
                      className="register-stage2-record-card__remove"
                      onClick={() => removeEducationRecord(index)}
                      disabled={loading}
                    >
                      <FaTrash />
                    </button>
                  )}
                </div>

                <div className="register-stage2-form__grid register-stage2-form__grid--4col">
                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Qualification</label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.qualification}
                      onChange={(e) => handleRecordChange(setEducationRecords, index, "qualification", e.target.value)}
                      placeholder="Bachelor of Engineering"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Discipline</label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.discipline}
                      onChange={(e) => handleRecordChange(setEducationRecords, index, "discipline", e.target.value)}
                      placeholder="Mechanical Engineering"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Institute</label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.institute}
                      onChange={(e) => handleRecordChange(setEducationRecords, index, "institute", e.target.value)}
                      placeholder="University Name"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Country</label>
                    <select
                      className="register-stage2-form__select"
                      value={record.country}
                      onChange={(e) => handleRecordChange(setEducationRecords, index, "country", e.target.value)}
                      disabled={loading}
                    >
                      <option value="">Select country</option>
                      {COUNTRY_OPTIONS.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </select>
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Start Date</label>
                    <input
                      type="date"
                      className="register-stage2-form__input"
                      value={record.start_date}
                      onChange={(e) => handleRecordChange(setEducationRecords, index, "start_date", e.target.value)}
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">End Date</label>
                    <input
                      type="date"
                      className="register-stage2-form__input"
                      value={record.end_date}
                      onChange={(e) => handleRecordChange(setEducationRecords, index, "end_date", e.target.value)}
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Grade</label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.grade}
                      onChange={(e) => handleRecordChange(setEducationRecords, index, "grade", e.target.value)}
                      placeholder="First Class"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__grid register-stage2-form__grid--1col">
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">Certificate Document</label>
                      <div className="register-stage2-form__file-upload">
                        <input
                          type="file"
                          id={`edu-file-${index}`}
                          className="register-stage2-form__file-input"
                          accept=".pdf,.jpg,.jpeg,.png"
                          onChange={(e) => handleRecordFileChange(setEducationRecords, index, e.target.files?.[0] || null)}
                          disabled={loading}
                        />
                        <label htmlFor={`edu-file-${index}`} className="register-stage2-form__file-label">
                          <span className="register-stage2-form__file-icon">📄</span>
                          <span>{record.file_name || "Upload certificate"}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </>
        )}
      </div>

      {/* Section 7: Certifications */}
      <div className="register-stage2-section">
        <div
          className="register-stage2-section__header"
          onClick={() => toggleSection("certification")}
        >
          <div className="register-stage2-section__header-top">
            <h3 className="register-stage2-section__title">
              <span className="register-stage2-section__icon">🏅</span>
              7. Certifications
            </h3>
            <div className="register-stage2-section__header-actions">
              <button
                type="button"
                className="register-stage2-add-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  addRecord(setCertificationRecords, createEmptyCertification);
                }}
                disabled={loading}
              >
                <FaPlus /> Add Certification
              </button>
              <span className="register-stage2-section__chevron">
                {expandedSections.certification ? <FaChevronUp /> : <FaChevronDown />}
              </span>
            </div>
          </div>
          <p className="register-stage2-section__subtitle">
            Competency evidence and professional credentials.
          </p>
        </div>

        {expandedSections.certification && (
          <>
            {errors.certification && (
              <span className="register-stage2-form__error-text register-stage2-form__error-text--block">
                {errors.certification}
              </span>
            )}

            {certificationRecords.map((record, index) => (
              <div key={record.id} className="register-stage2-record-card">
                <div className="register-stage2-record-card__header">
                  <h4 className="register-stage2-record-card__title">
                    Certification #{index + 1}
                  </h4>
                  {certificationRecords.length > 1 && (
                    <button
                      type="button"
                      className="register-stage2-record-card__remove"
                      onClick={() => removeCertificationRecord(index)}
                      disabled={loading}
                    >
                      <FaTrash />
                    </button>
                  )}
                </div>

                <div className="register-stage2-form__grid register-stage2-form__grid--4col">
                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Certifying Body</label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.body}
                      onChange={(e) => handleRecordChange(setCertificationRecords, index, "body", e.target.value)}
                      placeholder="AWS, NACE, etc."
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Certification</label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.certification}
                      onChange={(e) => handleRecordChange(setCertificationRecords, index, "certification", e.target.value)}
                      placeholder="CSWIP 3.1"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Level</label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.level}
                      onChange={(e) => handleRecordChange(setCertificationRecords, index, "level", e.target.value)}
                      placeholder="Level 2"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Certificate Number</label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.number}
                      onChange={(e) => handleRecordChange(setCertificationRecords, index, "number", e.target.value)}
                      placeholder="CERT-12345"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Status</label>
                    <select
                      className="register-stage2-form__select"
                      value={record.status}
                      onChange={(e) => handleRecordChange(setCertificationRecords, index, "status", e.target.value)}
                      disabled={loading}
                    >
                      <option value="Active">Active</option>
                      <option value="Expired">Expired</option>
                      <option value="Suspended">Suspended</option>
                    </select>
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Linked scope</label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.linked_scope}
                      onChange={(e) => handleRecordChange(setCertificationRecords, index, "linked_scope", e.target.value)}
                      placeholder="e.g. NDT Surveillance — optional link"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Issue Date</label>
                    <input
                      type="date"
                      className="register-stage2-form__input"
                      value={record.issue_date}
                      onChange={(e) => handleRecordChange(setCertificationRecords, index, "issue_date", e.target.value)}
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Expiry Date</label>
                    <input
                      type="date"
                      className="register-stage2-form__input"
                      value={record.expiry_date}
                      onChange={(e) => handleRecordChange(setCertificationRecords, index, "expiry_date", e.target.value)}
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__grid register-stage2-form__grid--1col">
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">Certificate Document</label>
                      <div className="register-stage2-form__file-upload">
                        <input
                          type="file"
                          id={`cert-file-${index}`}
                          className="register-stage2-form__file-input"
                          accept=".pdf,.jpg,.jpeg,.png"
                          onChange={(e) => handleRecordFileChange(setCertificationRecords, index, e.target.files?.[0] || null)}
                          disabled={loading}
                        />
                        <label htmlFor={`cert-file-${index}`} className="register-stage2-form__file-label">
                          <span className="register-stage2-form__file-icon">📄</span>
                          <span>{record.file_name || "Upload certificate"}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </>
        )}
      </div>

      {/* Section 8: Training */}
      <div className="register-stage2-section">
        <div
          className="register-stage2-section__header"
          onClick={() => toggleSection("training")}
        >
          <div className="register-stage2-section__header-top">
            <h3 className="register-stage2-section__title">
              <span className="register-stage2-section__icon">📚</span>
              8. Training
            </h3>
            <div className="register-stage2-section__header-actions">
              <button
                type="button"
                className="register-stage2-add-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  addTraining();
                }}
                disabled={loading}
              >
                <FaPlus /> Add Training
              </button>
              <span className="register-stage2-section__chevron">
                {expandedSections.training ? <FaChevronUp /> : <FaChevronDown />}
              </span>
            </div>
          </div>
          <p className="register-stage2-section__subtitle">
            Professional training courses and workshops.
          </p>
        </div>

        {expandedSections.training && (
          <>
            {trainingRecords.map((record, index) => (
              <div key={record.id} className="register-stage2-record-card">
                <div className="register-stage2-record-card__header">
                  <h4 className="register-stage2-record-card__title">
                    Training #{index + 1}
                  </h4>
                  {trainingRecords.length > 1 && (
                    <button
                      type="button"
                      className="register-stage2-record-card__remove"
                      onClick={() => removeTraining(index)}
                      disabled={loading}
                    >
                      <FaTrash />
                    </button>
                  )}
                </div>

                <div className="register-stage2-form__grid register-stage2-form__grid--4col">
                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Course Name</label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.course_name}
                      onChange={(e) => handleTrainingChange(index, "course_name", e.target.value)}
                      placeholder="Course name"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Provider</label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.provider}
                      onChange={(e) => handleTrainingChange(index, "provider", e.target.value)}
                      placeholder="Training provider"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Start date</label>
                    <input
                      type="date"
                      className="register-stage2-form__input"
                      value={record.start_date}
                      onChange={(e) => handleTrainingChange(index, "start_date", e.target.value)}
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">End date</label>
                    <input
                      type="date"
                      className="register-stage2-form__input"
                      value={record.end_date}
                      onChange={(e) => handleTrainingChange(index, "end_date", e.target.value)}
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Validity / Expiry</label>
                    <input
                      type="date"
                      className="register-stage2-form__input"
                      value={record.expiry_date}
                      onChange={(e) => handleTrainingChange(index, "expiry_date", e.target.value)}
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__grid register-stage2-form__grid--1col">
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">Training evidence</label>
                      <div className="register-stage2-form__file-upload">
                        <input
                          type="file"
                          id={`training-file-${index}`}
                          className="register-stage2-form__file-input"
                          accept=".pdf,.jpg,.jpeg,.png"
                          onChange={(e) => handleRecordFileChange(setTrainingRecords, index, e.target.files?.[0] || null)}
                          disabled={loading}
                        />
                        <label htmlFor={`training-file-${index}`} className="register-stage2-form__file-label">
                          <span className="register-stage2-form__file-icon">📄</span>
                          <span>{record.file_name || "Upload training evidence"}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </>
        )}
      </div>

      <div className="register-stage2-form__actions">
        <button
          type="button"
          className="register-stage2-form__btn register-stage2-form__btn--outline"
          onClick={onBack}
          disabled={loading}
        >
          ← Previous Tab
        </button>
        <button
          type="button"
          className="register-stage2-form__btn register-stage2-form__btn--primary"
          onClick={onSubmit}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit & Continue"}
        </button>
      </div>
    </div>
  );
};

export default Tab2Qualifications;